module.exports = __webpack_public_path__ + "img/shili2.92d1aefb.jpg";